<script setup lang="ts">
import { Icon, LayoutGap } from '@dabble/quillui';
import { computed } from 'vue';

const props = defineProps<{ features?: { name: string }[] | null }>();

const applicableFeatures = computed(() => props.features?.map((f) => f.name).filter(Boolean) ?? []);
</script>

<template>
  <LayoutGap direction="column" size="xsmall" class="plan-feature-list">
    <LayoutGap
      v-for="feature in applicableFeatures"
      :key="feature"
      direction="row"
      vertical-align="center"
      size="xsmall"
      class="feature-item"
    >
      <Icon name="check" class="check-icon" />
      <span class="feature-name">{{ feature }}</span>
    </LayoutGap>
  </LayoutGap>
</template>

<style lang="scss" scoped>
.feature-item {
  line-height: 1.3;
  width: 100%;
}

.check-icon {
  color: var(--color-success, #10b981);
  flex-shrink: 0;
}

.feature-name {
  flex-grow: 1;
  min-width: 0;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
</style>
